module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ei3E1a/tc-custom/9781788855082.jpg?1709101429445",
      "alt": "This image is the cover for the book Coffin Roads"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Coffin Roads\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Scottish minister’s meditative journey through the Highlands and islands, along the historic roads used to carry the dead for burial in the west.")]), _c('br'), _c('br'), _vm._v("Across the Scottish Highlands, and through the islands of the Inner and Outer Hebrides, run ancient paths specially designated for carrying the dead to their final resting place. These roads, many of which are now used as walking and cycling routes, are rich in both cultural history and natural beauty. "), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("The coffin Roads")]), _vm._v(", Reverend Dr. Ian Bradley journeys along eight coffin roads to explore the distinctive communities which created and used them. Along the way, he delves into their various traditions, beliefs, and practices around dying, death and mourning. Bradley offers a fascinating look the traditional Highland way of life, and reveals how its distinctive ways of grappling with death offer important insights for us today. "), _c('br'), _c('br'), _vm._v("Readers are taken along Iona’s famous Street of the Dead; Kilearnadil Graveyard on the island of Jura; St. Finan’s Isle, the older continuously used burial place in Europe; among other beautiful and fascinating locations.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ian Bradley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The Rev. Dr Ian Bradley has written over 40 books and is well-known as a  broadcaster, journalist and lecturer. He is also a Church of Scotland minister and a respected academic whose enthusiasm shines through in all that he does.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Birlinn\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0